import * as React from 'react';

import { Query } from 'react-apollo';
// @ts-ignore
import { connect } from 'react-redux';

// @ts-ignore
import UnreadActions from 'actions/UnreadActions';
import ErrorReporter from 'app/components/ErrorReporter';
import OverlayLoading from 'components/OverlayLoading';
// @ts-ignore
import ClassNavigationPromotionContainer from 'groups/containers/ClassNavigationPromotionContainer';
// @ts-ignore
import UnreadStore from 'stores/UnreadStore';

import NavigationListLoadTimer from './NavigationListLoadTimer';
import NavigationListSection from './NavigationListSection';
import NavigationListSectionActions from './NavigationListSectionActions';
import NavigationListSectionItems from './NavigationListSectionItems';

import {
    NavigationList as NavigationListQuery, NavigationList_me_navigationSections
} from 'queries/__generated__/NavigationList';

import NavigationQuery from 'queries/navigationList.gql';

import './styles/NavigationList.scss';

export const TOUCH_KEY = 'NAVIGATION_LIST';

type Props = {
  touch: string;
  onRefetch?: () => void;
};

type State = {
  lastSeenTouch?: string;
};

class NavigationList extends React.Component<Props, State> {
  state: State = {
    lastSeenTouch: undefined,
  };

  componentDidMount() {
    if (UnreadStore.getUnreads().isEmpty()) {
      UnreadActions.loadUnreads();
    }
  }

  renderSection = (section: NavigationList_me_navigationSections) => {
    const isDistrictSection = section.key === 'districts';
    return (
      <NavigationListSection key={section.key} title={section.label || undefined}>
        <NavigationListSectionActions actions={section.actions || []} />
        <NavigationListSectionItems
          items={section.items || []}
          isDistrictSection={isDistrictSection}
        />
      </NavigationListSection>
    );
  };

  render() {
    return (
      <Query<NavigationListQuery> query={NavigationQuery} notifyOnNetworkStatusChange>
        {({ loading, error, data, refetch }) => {
          if (this.state.lastSeenTouch !== this.props.touch) {
            refetch();

            if (this.props.onRefetch) {
              this.props.onRefetch();
            }

            this.setState({
              lastSeenTouch: this.props.touch,
            });
          }

          if (error) {
            return <ErrorReporter error="NavigationList - failed to load navigation sections" />;
          }

          const sections = data && data.me && data.me.navigationSections;

          const navList = sections ? (
            <nav className="NavigationList-content">
              <NavigationListLoadTimer />
              <ClassNavigationPromotionContainer />
              {sections.map(this.renderSection)}
            </nav>
          ) : null;

          return (
            <div className="NavigationList" style={{ position: 'relative' }}>
              {loading && <OverlayLoading />}
              {navList}
            </div>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    touch: state.touch.get(TOUCH_KEY),
  };
}

export { NavigationList };
export default connect<any, any, Props>(
  mapStateToProps,
  undefined
)(NavigationList);
